import { Typography } from "@mui/material";

const EmployeeNameComponent = ({ employee }) => (
  <>
    <Typography
      sx={{
        borderBottom: "1px solid #BDBDBD",
        height: "0", // or however tall you want the underline
        display: "block", // make sure it's treated as a block element
        mb: 1,
        width: "100%",
      }}
    >
      &nbsp;
    </Typography>
    <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
      {employee && `${employee?.first_name} ${employee?.last_name}`}
    </Typography>
    <Typography sx={{ fontSize: 12, fontWeight: 400 }}>
      {employee && employee?.position}
    </Typography>
  </>
);
export default EmployeeNameComponent;
